/**
 * Clamps text with CSS (clamp-text.css) and shows the toggle only when the text
 * actually overflows. The full text is always in the DOM, so it stays indexable.
 */
if (!customElements.get('clamp-text')) {
  class ClampText extends HTMLElement {
    connectedCallback() {
      this.content = this.querySelector('.clamp-text__content');
      this.toggle = this.querySelector('.clamp-text__toggle');
      if (!this.content || !this.toggle) return;

      this.toggle.addEventListener('click', this.handleToggle.bind(this));
      this.resizeObserver = new ResizeObserver(() => this.update());
      this.resizeObserver.observe(this.content);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    /**
     * Shows the toggle when the clamped text overflows (mobile), hides it otherwise.
     */
    update() {
      if (this.classList.contains('is-expanded')) return;
      const overflows = this.content.scrollHeight > this.content.clientHeight + 1;
      this.toggle.hidden = !overflows;
      this.classList.toggle('is-clamped', overflows);
    }

    /**
     * Expands or collapses the text.
     */
    handleToggle() {
      const expanded = this.classList.toggle('is-expanded');
      this.toggle.setAttribute('aria-expanded', expanded);
      this.toggle.textContent = expanded ? this.toggle.dataset.less : this.toggle.dataset.more;
    }
  }

  customElements.define('clamp-text', ClampText);
}
